import useAxios from 'axios-hooks'
import { isEmpty } from 'lodash'
import { captureException } from '@sentry/browser'

import type { UseAxiosResult } from 'axios-hooks'
import { fetchAPI } from 'libs/apis'

import { getSessionStorage, removeSessionStorage } from 'helpers/common'

import { initialForm } from 'features/Profile'
import type {
  IProfileNavigation,
  IProfile,
  IProfileFormProps,
} from 'features/Profile'
import { IResponseService } from 'types'

export const useGetProfile = (): UseAxiosResult<IProfileNavigation> => {
  const path = `${window._env_.REACT_APP_API_URL}/v1/user/profile`

  return useAxios({
    url: path,
  })
}

export const getSessionStorageProfile = (): IProfile => {
  const profileId = getSessionStorage('profileId')
  const profileName = getSessionStorage('profileName')
  const profileImage = getSessionStorage('profileImage') || undefined
  const profileFullName = getSessionStorage('profileFullName') || undefined

  return {
    profileId,
    profileName,
    profileImage: profileImage === 'undefined' ? undefined : profileImage,
    profileFullName:
      profileFullName === 'undefined' ? undefined : profileFullName,
  }
}

export const removeSessionStorageProfile = (): void => {
  removeSessionStorage('profileId')
  removeSessionStorage('profileName')
  removeSessionStorage('profileImage')
  removeSessionStorage('profileFullName')
}

export const findUserById = async (
  id: string,
): Promise<IResponseService<IProfileFormProps>> => {
  try {
    if (isEmpty(id)) {
      return { data: initialForm }
    }

    const response = await fetchAPI<IProfileFormProps>({
      apiUrl: window._env_.REACT_APP_API_URL,
      method: 'GET',
      path: `/v1/user/${id}`,
    })

    return { data: response.body }
  } catch (error) {
    captureException(error)

    return { error }
  }
}
